module.exports = __webpack_public_path__ + "static/media/vf-button-men-shirts.f655f479.svg";